import { Check } from 'lucide-react'
import type { ComponentType } from 'react'

interface SelectableCardGridProps {
  options: ReadonlyArray<{
    id: string
    label: string
    hint?: string
    Icon?: ComponentType<{ className?: string }>
  }>
  value: string[]
  onChange: (ids: string[]) => void
  multiple?: boolean
}

export function SelectableCardGrid({
  options,
  value,
  onChange,
  multiple = false,
}: SelectableCardGridProps) {
  const toggle = (id: string): void => {
    if (multiple) {
      onChange(value.includes(id) ? value.filter((x) => x !== id) : [...value, id])
    } else {
      onChange([id])
    }
  }

  return (
    <div className="grid grid-cols-4 gap-2.5" role={multiple ? 'group' : 'radiogroup'}>
      {options.map((opt) => {
        const { Icon } = opt
        const isSelected = value.includes(opt.id)
        return (
          <button
            key={opt.id}
            type="button"
            role={multiple ? 'checkbox' : 'radio'}
            aria-checked={isSelected}
            className="alm-tile"
            data-selected={isSelected}
            onClick={() => toggle(opt.id)}
          >
            {Icon ? <Icon className="h-5 w-5 text-indigo-300" /> : null}
            <div className="text-sm font-semibold text-slate-100 leading-tight">{opt.label}</div>
            {opt.hint ? (
              <div className="text-[11px] text-slate-400 leading-tight">{opt.hint}</div>
            ) : null}
            <Check className="h-4 w-4 alm-tile-check" />
          </button>
        )
      })}
    </div>
  )
}
